export default __webpack_public_path__ + "e2856bd286de4152c8a22d106a76ca6c.svg";